class ThemeSlider extends HTMLElement {
  labels = []; inputs; values; min; max; step;
  
  constructor() {
    super();
    this.init();
  }

  init = () => {
    if(this.dataset.labels !== undefined){
      const labels = this.dataset.labels.split(',');
      labels.forEach(label => {
        const labelElement = document.querySelector(label);
        if(labelElement !== null){
          this.labels.push(labelElement);
        }
      });
    }

    this.inputs = this.querySelectorAll('input');
    const values = this.dataset.values.split(',');
    this.values = values.map(value => parseInt(value));

    this.min = parseInt(this.dataset.min);
    this.max = parseInt(this.dataset.max);
    this.step = this.dataset.step == undefined ? 1 : parseInt(this.dataset.step);
    
    noUiSlider.create(this, {
      start: this.values,
      connect: true,
      range: {
        'min': this.min,
        'max': this.max
      },
      step: this.step
    });

    this.noUiSlider.on('update', (values) => {
      this.setValues(values);
    });

    this.noUiSlider.on('change', (values) => {
      this.setInputs(values);
      this.dispatchEvent(new CustomEvent(Utils.E_SLIDER_CHANGE, { detail: this.values }));
    });
  }

  setInputs = (values) => {
    this.values = values;
    this.inputs.forEach((input, index) => {
      input.value = this.values[index];
    });
  }

  setValues = (values) => {
    this.values = values;
    this.setLabels();
  }

  setLabels = () => {
    if(this.labels.length > 0){
      this.labels.forEach((label, index) => {
        label.innerHTML = this.format(this.values[index]);
      });
    }
  }

  format = (value) => {
    const format = this.dataset.format || '{label}';
    if(format == 'money')
      return Utils.money(value);
    else
      return format.replaceAll('{label}', value);
  }
  
}
if (!window.customElements.get("theme-slider")) {
  window.customElements.define("theme-slider", ThemeSlider);
}